import { render } from "@testing-library/react";
import { ThemeProvider } from "styled-components";
import Terria from "../../../../../lib/Models/Terria";
import ViewState from "../../../../../lib/ReactViewModels/ViewState";
import Compass from "../../../../../lib/ReactViews/Map/MapNavigation/Items/Compass/Compass";
import { terriaTheme } from "../../../../../lib/ReactViews/StandardUserInterface";
import { jsx as _jsx } from "react/jsx-runtime";
describe("Compass", function () {
  let terria;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria: terria,
      catalogSearchProvider: undefined
    });
  });
  describe("with basic props", function () {
    it("renders", function () {
      const {
        container
      } = render(/*#__PURE__*/_jsx(ThemeProvider, {
        theme: terriaTheme,
        children: /*#__PURE__*/_jsx(Compass, {
          theme: terriaTheme,
          viewState: viewState,
          terria: terria
        })
      }));
      const icons = container.querySelectorAll("svg");
      expect(icons.length).toBe(4);
    });
  });
});